<template>
  <div class="reports">
    <!-- switch type search -->
    <v-container>
      <v-row>
        <v-switch
          v-model="showFilters"
          label="Mostrar filtros"
          class="mt-0 mb-3"
          color="secondary"
          hide-details
        ></v-switch>
        <v-spacer></v-spacer>
        <v-btn class="mx-2" fab right color="secondary" small @click="reload">
          <v-icon> mdi-reload </v-icon>
        </v-btn>
      </v-row>
    </v-container>

    <!-- Filters text search -->
    <v-card class="mb-2" v-if="showFilters">
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="6" md="6" class="py-0">
            <v-text-field
              label="Filtre # de informe, por cedula o nombre del colaborador"
              outlined
              hide-details
              dense
              append-icon="mdi-magnify"
              v-model="searchInput"
              clearable
              clear-icon="mdi-close-circle"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="2" class="py-0">
            <v-btn block color="secondary" @click="searchText"> Buscar </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- Filters date and options search -->
    <v-card class="mb-2" v-if="showFilters">
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="6" md="4">
            <VueCtkDateTimePicker
              color="DodgerBlue"
              v-model="datePiker.model"
              :label="datePiker.label"
              :range="true"
              :custom-shortcuts="datePiker.shortcut"
              :format="datePiker.format"
              :formatted="datePiker.formatted"
              inputSize="sm"
            />
          </v-col>
          <v-col cols="12" sm="12" md="3">
            <v-select
              outlined
              :items="this.$store.state.status.reportStatus"
              label="Seleccione Estado"
              no-data-text="No hay registros..."
              hide-details
              dense
              v-model="filters.status"
            ></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <v-btn block color="secondary" @click="searchFilters">
              Buscar
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- Table -->
    <v-card>
      <v-data-table
        :headers="headers"
        :items="this.$store.state.report.reports.reports.data"
        :search="search"
        hide-default-footer
        :items-per-page="20"
        :loading="this.$store.state.report.reports.isLoading"
        loading-text="Cargando... Por favor espere"
        no-data-text="No hay registro"
        no-results-text="Lo sentimos no hay registro para su busqueda, intente con otro"
      >
        <template v-slot:[`item.reference`]="item">
          <v-chip color="primary" small>
            {{ item.item.reference }}
          </v-chip>
        </template>
        <template v-slot:[`item.referenceContract`]="item">
          {{ item.item.contract.reference }}
        </template>
        <template v-slot:[`item.employee`]="item">
          {{ item.item.contract.employee.user.full_name }}
        </template>
        <template v-slot:[`item.status`]="item">
          <v-chip :color="getReportStatuColor(item.item.status)" dark small>
            {{ getReportStatus(item.item.status) }}
          </v-chip>
        </template>
        <template v-slot:[`item.actions`]="item">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="primary"
                dark
                v-bind="attrs"
                v-on="on"
                class="px-1"
                @click="show(item.item.id)"
              >
                mdi-eye-outline
              </v-icon>
            </template>
            <span>Ver</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="green"
                dark
                v-bind="attrs"
                v-on="on"
                class="px-1"
                @click="open(item.item)"
                v-if="item.item.report_url"
              >
                mdi-file-download
              </v-icon>
            </template>
            <span>Descargar Informe</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="red"
                dark
                v-bind="attrs"
                v-on="on"
                class="px-1"
                @click="upload(item.item)"
                target="_blank"
                v-if="
                  role == 'EMPLOYEE' &&
                  item.item.report_url &&
                  !item.item.report_signed_url &&
                  user.id == item.item.contract.employee.user.id
                "
              >
                mdi-file-upload
              </v-icon>
            </template>
            <span>Subir Informe Firmado</span>
          </v-tooltip>
          <v-tooltip bottom v-if="!item.item.bill">
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="yellow darken-4"
                dark
                v-bind="attrs"
                v-on="on"
                class="px-1"
                @click="createBill(item.item)"
                target="_blank"
                v-if="
                  item.item.status == 'APPROVED' &&
                  user.id == item.item.contract.employee.user.id        
                "
              >
                mdi-text-box-plus
              </v-icon>
            </template>
            <span>Crear Cuenta Cobro</span>
          </v-tooltip>
          <v-tooltip
            bottom
            v-if="item.item.status !== 'CANCELED' && role == 'ADMINISTRATOR'"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="red"
                dark
                v-bind="attrs"
                v-on="on"
                class="px-1"
                @click="changeStatus('CANCELED', item.item)"
              >
                mdi-file-cancel
              </v-icon>
            </template>
            <span>Inactivar</span>
          </v-tooltip>
          <v-tooltip bottom v-if="role == 'ADMINISTRATOR'">
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="red"
                dark
                v-bind="attrs"
                v-on="on"
                @click="distroy(item.item)"
                class="px-1"
              >
                mdi-delete
              </v-icon>
            </template>
            <span>Eliminar</span>
          </v-tooltip>
        </template>
      </v-data-table>

      <v-col cols="12" sm="12" md="12">
        <v-pagination
          v-model="pagination.current"
          :length="pagination.total"
          :total-visible="8"
          circle
          @input="nextPage"
        ></v-pagination>
      </v-col>
    </v-card>

    <!-- Dialog upload contract signed -->
    <v-dialog v-model="dialogUpload" width="500" persistent>
      <v-card>
        <v-card-title v-if="currentReport">
          Subir Informe Firmado - #{{ currentReport.reference }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form ref="formUpload" v-model="formUpload">
            <v-file-input
              accept="application/pdf,application/vnd.ms-excel,image/*,.doc,.docx,.pdf"
              label="Informe Firmado"
              v-model="model.report_signed_file"
              :rules="[
                this.$store.state.rules.required,
                this.$store.state.rules.max_file,
              ]"
              show-size
            ></v-file-input>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="red" @click="cancelUpload">Cancelar</v-btn>
          <v-btn text color="primary" @click="saveUpload">Subir</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog create bill -->
    <v-dialog v-model="dialogBill" width="500" persistent>
      <v-card>
        <v-card-text v-if="currentReport" class="pt-4">
          <h3>
            Seguro que desea generar cuenta de cobro para el informe #{{
              currentReport.reference
            }}?
          </h3>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="red" @click="cancelBill">Cancelar</v-btn>
          <v-btn text color="primary" @click="createBillConfirmation"
            >Crear</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog change status -->
    <v-dialog v-model="dialogChangeStatus" width="500" persistent>
      <v-card>
        <v-card-title v-if="currentReport && statusText != ''" class="d-block">
          <p class="text-center">
            Seguro que desea cambiar a {{ getReportStatus(statusText) }}
            <br />
            el reporte - #{{ currentReport.reference }}
          </p>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="red" @click="cancelCangeStatus">Cancelar</v-btn>
          <v-btn text color="primary" @click="changeStatusConfirmation"
            >Aceptar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- delete dialog -->
    <v-dialog v-model="dialogDelete" width="500" persistent>
      <v-card>
        <v-card-text class="py-4">
          Seguro que desea eliminar este reporte?
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="success"
            class="mr-4"
            @click="distroyConfirmation"
            small
          >
            Confirmar
          </v-btn>

          <v-btn color="error" text class="mr-4" @click="closeDistroy" small>
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { SET_REPORTS } from "@/store/report/reports";
import { SET_ALERT } from "@/store/alert";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
export default {
  name: "Reports",
  filters: {
    formatNumber(value) {
      return new Intl.NumberFormat("es-CO", {
        style: "currency",
        currency: "COP",
      }).format(value);
    },
  },
  components: {
    VueCtkDateTimePicker,
  },
  data: () => ({
    isNull: null,
    search: "",
    showFilters: false,
    searchInput: "",
    formUpload: true,
    dialogDelete: false,
    dialogUpload: false,
    dialogBill: false,
    dialogChangeStatus: false,
    statusText: "",
    headers: [
      {
        text: "# Informe",
        value: "reference",
        filterable: true,
        sortable: true,
      },
      {
        text: "P. Inicio",
        value: "period_start_date",
        filterable: true,
        sortable: true,
      },
      {
        text: "P. Finalización",
        value: "period_end_date",
        filterable: true,
        sortable: true,
      },
      {
        text: "# Contrato",
        value: "referenceContract",
        filterable: true,
        sortable: true,
      },
      {
        text: "Colaborador",
        value: "employee",
        filterable: true,
        sortable: true,
      },
      { text: "Estado", value: "status", filterable: true, sortable: false },
      { text: "Acciones", value: "actions", filterable: true, sortable: false },
    ],
    filters: {
      status: "",
    },
    pagination: {
      current: 0,
      total: 0,
    },
    model: {
      report_signed_file: null,
    },
    rules: {
      file: (value) => !value || "Documento obligatorio",
      max_file: (value) =>
        !value ||
        value.size < 20971520 ||
        "El documento debe pesar menos de 20MB",
    },
    currentReport: null,
  }),
  created() {
    this.$store.dispatch("getReports");
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === SET_REPORTS) {
        this.pagination.current = state.report.reports.reports.current_page;
        this.pagination.total = state.report.reports.reports.last_page;      
      }
    });
  },
  computed: {
    ...mapGetters(["getReportStatuColor", "getReportStatus"]),
    role() {
      return this.$store.state.user.user != null
        ? this.$store.state.user.user.role
        : "";
    },
    user() {
      return this.$store.state.user.user != null
        ? this.$store.state.user.user
        : "";
    },
    datePiker() {
      return this.$store.state.status.datePiker;
    },
  },
  methods: {
    show(id) {
      window.open(`/reports/show/${id}`, '_blank').focus();      
    },
    nextPage() {
      this.$store.dispatch("nextPageReports", this.pagination.current);
    },
    open(report) {
      window.open(report.report_url, "_blank");
    },
    upload(report) {
      this.currentReport = report;
      this.dialogUpload = true;
    },
    cancelUpload() {
      this.currentReport = null;
      this.dialogUpload = false;
    },
    saveUpload() {
      if (this.model.report_signed_file == null) {
        this.$store.commit(SET_ALERT, {
          message: "Debe seleccionar un archivo",
          type: "error",
        });
        return;
      }

      this.model._method = "put";
      this.$store.dispatch("updateReport", {
        id: this.currentReport.id,
        form: this.createFormData(),
      });
      this.cancelUpload();
    },
    createFormData() {
      let formData = new FormData();
      Object.entries(this.model).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          value.forEach((element, index) => {
            formData.append(key + "[" + index + "]", element);
          });
        } else {
          formData.append(key, value);
        }
      });
      return formData;
    },
    createBill(report) {
      this.currentReport = report;
      this.dialogBill = true;
    },
    cancelBill() {
      this.currentReport = null;
      this.dialogBill = false;
    },
    createBillConfirmation() {
      this.$store.dispatch("createBill", {
        report_id: this.currentReport.id,
        contract_id: this.currentReport.contract.id
      });
      this.cancelBill();
    },
    reload() {
      this.searchInput = "";
      this.filters = {
        status: "",
      };
      this.datePiker.model = null;
      this.searchFiltersText = "";
      this.showFilters = false;
      this.$store.dispatch("getReports");
    },
    searchText() {
      if (this.searchLoanInput == "") {
        this.$store.commit(SET_ALERT, {
          message: "Ingrese un valor de busqueda",
          type: "info",
        });
        return;
      }
      this.showFilters = false;
      this.$store.dispatch("getReports", "search=" + this.searchInput + "&");
    },
    searchFilters() {
      this.searchFiltersText = "";

      if (this.datePiker.model !== null) {
        this.searchFiltersText =
          "min_date=" +
          this.datePiker.model.start +
          "&max_date=" +
          this.datePiker.model.end +
          "&";
      }

      if (this.filters.status !== "") {
        this.searchFiltersText += "status=" + this.filters.status + "&";
      }

      if (this.searchFiltersText == "") {
        this.$store.commit(SET_ALERT, {
          message: "Ingrese un valor de busqueda",
          type: "info",
        });
        return;
      }

      this.showFilters = false;
      this.$store.dispatch("getReports", this.searchFiltersText);
    },
    changeStatus(status, contract) {
      this.currentReport = contract;
      this.statusText = status;
      this.dialogChangeStatus = true;
    },
    cancelCangeStatus() {
      this.currentReport = null;
      this.statusText = "";
      this.dialogChangeStatus = false;
    },
    changeStatusConfirmation() {
      this.$store.dispatch("updateReport", {
        id: this.currentReport.id,
        form: {
          status: this.statusText,
          _method: "put",
        },
      });
      this.cancelCangeStatus();
    },
    distroy(report) {
      this.currentReport = report;
      this.dialogDelete = true;
    },
    distroyConfirmation() {
      this.$store.dispatch("deleteReport", this.currentReport.id);
      this.closeDistroy();
    },
    closeDistroy() {
      this.currentReport = null;
      this.dialogDelete = false;
    },
  },
};
</script>
<style scoped>
.user {
  height: 100%;
}
.v-btn--bottom {
  bottom: 11px !important;
}
</style>
